import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import Dashboard from '@/pages/Dashboard';
import StudentRegistration from '@/pages/StudentRegistration';
import PsychomotorEvaluation from '@/pages/PsychomotorEvaluation';
import StudentEvolution from '@/pages/StudentEvolution';
import StudentDashboard from '@/pages/StudentDashboard';
import { Toaster } from '@/components/ui/toaster';
import { SupabaseDataProvider } from '@/contexts/SupabaseDataContext';

function App() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [activeStudent, setActiveStudent] = useState(null);

  const navigateTo = (page, student = null) => {
    if (student) {
      setActiveStudent(student);
    }
    setCurrentPage(page);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'dashboard':
        return <Dashboard onNavigate={navigateTo} />;
      case 'registration':
        return <StudentRegistration onNavigate={navigateTo} />;
      case 'studentDashboard':
        return <StudentDashboard onNavigate={navigateTo} student={activeStudent} />;
      case 'evaluation':
        return <PsychomotorEvaluation onNavigate={navigateTo} student={activeStudent} />;
      case 'evolution':
        return <StudentEvolution onNavigate={navigateTo} student={activeStudent} />;
      default:
        return <Dashboard onNavigate={navigateTo} />;
    }
  };

  return (
    <SupabaseDataProvider>
      <Helmet>
        <title>Sistema de Avaliação Psicomotora - Pedalando pela Inclusão</title>
        <meta name="description" content="Sistema completo para registro de alunos e avaliação psicomotora no programa Pedalando pela Inclusão" />
      </Helmet>
      <div className="min-h-screen">
        <motion.div
          key={currentPage}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.3 }}
        >
          {renderPage()}
        </motion.div>
        <Toaster />
      </div>
    </SupabaseDataProvider>
  );
}

export default App;